<template>
  <div class="cm-acc-invoice-document" style="padding-top: 1px">
    <TextField2
      id="subject"
      :label="$t('main_subject')"
      :placeholder="$t('main_subject')"
      :textarea="true"
      :height="64"
      :disabled="selectedInvoice.disabled"
      :value="selectedInvoice.invoice.subject"
      @change="onTextFieldValueChange"
    />
    <TextField2
      id="leading_text"
      :label="$t('leading_text')"
      :placeholder="$t('enter') + ' ' + $t('leading_text')"
      :disabled="selectedInvoice.disabled"
      :value="selectedInvoice.invoice.leading_text"
      @change="onTextFieldValueChange"
    />
    <TextField2
      id="trailing_text"
      :textarea="true"
      :height="120"
      :bb="'0'"
      :label="$t('trailing_text')"
      :placeholder="$t('enter') + ' ' + $t('trailing_text')"
      :disabled="selectedInvoice.disabled"
      :value="selectedInvoice.invoice.trailing_text"
      @change="onTextFieldValueChange"
    />
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    selectedInvoice: {
      required: true,
    },
  },
  data: function () {
    return {};
  },
  computed: {},
  methods: {
    onTextFieldValueChange: function ({ name, value }) {
      this.$emit("changed", { name, value });
    },
    //MARK: METHODS
  },
};
</script>

<style lang="scss">
.cm-acc-invoice-document {
}
</style>
